import React from "react";
import classNames from "classnames";
import "./index.scss";

import ImageEditControl from "../ImageEditControl";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemImage = ({ column, value, onPropChange }) => {

  const handleOnLoad = (image) => {
    if(column.isReadonly){
      return;
    }

    onPropChange({ [column.accessor]: image })
  }

  return (
    <div key={`propItem-${column.accessor}`} className={classNames("sectionItemImage", { full: column.isFullHeight })}>
      <ColumnTitleWithIcon item={value} column={column} onPropChange={onPropChange} />
      <ImageEditControl img={value} isFullHeight={column.isFullHeight} disabled={column.isReadonly}
        onLoadImage={image => handleOnLoad(image)}
      />
    </div>
  );
} 

export default SectionItemImage;
